import { type Dispatch, type SetStateAction, useState } from "react";
import { useIntl } from "react-intl";
import { sendAnalyticsInteractionEvent } from "src/analytics/sendAnalyticsEvent";
import { AgeSelect } from "src/domain/SegmentScreen/SegmentHeader/PassengerPicker/PassengerPickerForm/AgeSelect";
import type { Child, RoomDetail } from "../../HotelsContext";
import messages from "./RoomDetails.messages";

type ChildAgeSelectProps = {
  roomIndex: number;
  childIndex: number;
  freshFormData: RoomDetail[];
  setFreshFormData: Dispatch<SetStateAction<RoomDetail[]>>;
  childAge?: number;
};

const MIN_CHILD_AGE = 0;
const MAX_CHILD_AGE = 18;

export function ChildAgeSelect({
  roomIndex,
  childIndex,
  childAge,
  freshFormData,
  setFreshFormData,
}: ChildAgeSelectProps) {
  const intl = useIntl();
  const [selectDisplay, setSelectDisplay] = useState(
    childAge?.toString() ?? "",
  );

  const handleOnChange = (age: string) => {
    sendAnalyticsInteractionEvent({
      category: "Hotels",
      action: "Click: ChildAgeSelect",
      label: `${age}`,
    });
    setSelectDisplay(age);
    const updatedRoomDetails: RoomDetail[] = JSON.parse(
      JSON.stringify(freshFormData),
    );
    const updatedChild: Child = {
      ...updatedRoomDetails[roomIndex].children[childIndex],
      age: age === "" ? undefined : Number(age),
    };
    updatedRoomDetails[roomIndex].children[childIndex] = updatedChild;
    setFreshFormData(updatedRoomDetails);
  };

  return (
    <li
      className="flex items-center justify-between p-3"
      key={childIndex}
      aria-label={intl.formatMessage(messages.childLabel, {
        number: childIndex + 1,
      })}
    >
      <label
        className="text-label-md select-none"
        htmlFor={`child-age-select-${childIndex}`}
      >
        {intl.formatMessage(messages.childLabel, {
          number: childIndex + 1,
        })}
      </label>
      <AgeSelect
        id={`child-age-select-${childIndex}`}
        age={selectDisplay}
        onChange={(age) => handleOnChange(age)}
        max={MAX_CHILD_AGE}
        min={MIN_CHILD_AGE}
      />
    </li>
  );
}
